<template>
    <div class="search-result-item">
        <div class="class-list">
            <div :class="'class-item'+(item.productManualUrl?' product':'')" v-for="item in items" :key="item.id">
                <div v-if="item.productManualUrl" @click="viewDetail(item)">
                    <div class="image-container">
                        <img :src="item.cover"
                             class="class-cover"/>
                    </div>
                    <div class="right-info">
                        <div class="class-title" v-html="item.title" ></div>
                        <div class="class-auth" v-html="item.introductionContent"></div>
                    </div>
                </div>
                <div v-if="!item.productManualUrl" @click="viewDetail(item)">
                    <img :src="item.cover"
                         class="class-cover"/>
                    <div class="right-info">
                        <div class="class-title" v-html="item.title"></div>
                        <div class="class-auth" v-html="item.introductionContent"></div>
                    </div>
                </div>
            </div>
        </div>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>
    import api from '@/api/calss-search'
    import file from '@/api/file'
    import storage from '@/plugins/storage'

    export default {
        name: "search-result-item",
        props: {
            items: Array
        },
        data() {
            return {
                token: storage.get('token'),
                loading: false
            }
        },
        methods: {
            viewPdf(item) {
                const url = window.origin + `/pdf/pdf-viewer/viewer.html?url=${JSON.parse(item.productManualUrl).url}`
                window.open(url)
            },
            viewDetail(item) {
                const preRouterName = this.$router.currentRoute.name
                const keyword = this.$router.currentRoute.query.keyword
                if(item.productManualUrl){
                    this.$router.push(`/service-center/detail?id=${item.id}&type=productManual&currentRoute=${preRouterName}&keyword=${keyword}`)
                }else {
                    this.$router.push(`/service-center/detail?id=${item.id}&type=liveCourse&currentRoute=${preRouterName}&keyword=${keyword}`)
                }
            },
            // 手册附件下载
            async annexDownload(item) {
                this.loading = true
                let downloadRes = await api.annexDownload({title: item.title, annexUrl: item.annexUrl})
                this.loading = false
                location.href = downloadRes
            },
            async downloadClassFiles(item) {
                this.coursesFiles = await file.getCourseFiles({}, {paths: {courseId: item.id}})
                if (!this.coursesFiles.length) {
                    this.$Message.info('暂无附件')
                } else {
                    const course = this.coursesFiles[0]
                    if (course.lockState === 1) { // 加锁状态
                        this.$Message.info(`课件将在开课后${this.course.unlockAttachmentTime}分钟后自动解锁`)
                        return
                    }
                    let domain = process.env.NODE_ENV === 'development' ? this.$config.courseFilesDomain : ''
                    let href = `${domain}/live/api/v1/outer/file/seaFile/download/${item.id}?path=${encodeURIComponent('/')}&fileName=${encodeURIComponent(course.name)}`
                    if (this.token) {
                        href += `&school_token=${this.token}`
                    }
                    if (sessionStorage.getItem('verify-md5')) {
                        href += `&verify-md5=${sessionStorage.getItem('verify-md5')}`
                    }
                    window.location.href = href
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .search-result-item {
        .class-list {
            .class-item {
                display: flex;
                margin-bottom: 0px;
                cursor: pointer;
                .image-container {
                    width: 202px;
                    height: 137px;
                    text-align: center;
                    display: inline-block;
                    border-radius: 1.3px;
                    padding: 5px 13px 0px 14px;
                    border: 1.3px solid #eaeaea;
                    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.08)
                }

                &.product {
                    .class-cover {
                        width: 88px;
                        height: 126.6px;
                        border-radius: 0;
                        border: 1.3px solid #eaeaea;
                        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.08)
                    }

                    .right-info {
                        display: inline-block;
                        position: relative;
                        top: -50px;
                        height: 137px;
                        text-align: left;
                        .file-download {
                            line-height: 15px;
                            position: relative;
                            top:48px;
                        }
                    }
                }

                .class-cover {
                    width: 206px;
                    height: 115px;
                    border-radius: 4px;
                    cursor: pointer;
                }

                /deep/ .right-info {
                    padding-left: 20px;
                    position: relative;
                    display: inline-block;
                    height: 115px;
                    top:-30px;
                    .class-title {
                        cursor: pointer;
                        text-align: left;
                        font-size: 16px;
                        font-weight: normal;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1.5;
                        letter-spacing: normal;
                        color: #212121;
                    }

                    /deep/ .search-result-highlight {
                        color: #ED6C00 !important;
                    }
                    .class-auth {
                        text-align: left;
                        font-size: 14px;
                        font-weight: normal;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: normal;
                        letter-spacing: normal;
                        color: #666666;
                        height: 60px;
                        max-width: 600px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 3;
                        overflow: hidden;
                    }
                }
            }
        }
    }

</style>